import {Storages} from "../../../controllers/Storages";
import {GetStorage} from "../../../../cuppa/reactComponents/GetStorage";
import {useState} from "react";
import "../../../../cuppa/components/cuppa.menu";
import {CuppaMenu} from "../../../../cuppa/components/cuppa.menu";
import {cuppa, log} from "../../../../cuppa/cuppa";
import {UserCtrl} from "../../../controllers/UserCtrl";
import {Language} from "../../../controllers/Language";
import {Utils} from "../../../controllers/Utils";
import {Constants} from "../../../controllers/Constants";

export function UserInfo(props){
	const [user, setUser] = useState();

	return (
		<>
			<div
				className={'flex d-row j-center a-center btn-alpha user-info m-r-0-s1100'}
				style={{background:'var(--bg-1)', padding:'0 2rem',  alignSelf:'stretch', borderWidth:'0 1px 0 1px', borderColor:'#eee', borderStyle:'solid', marginRight:20 }}
			>
				<GetStorage {...Storages.user} callback={setUser} />
				<div className={'image'} style={{width:32, height:32, borderRadius:32, marginRight:10, backgroundImage:`url('${require('../../../media/images/profile.png')}')`}}></div>
				<div className={'d-none-s1100'}>
					<div>{user?.name || ''} {user?.last_name || ''}</div>
					<div className={"f-12 o-75"}>{user?.role?.role}</div>
				</div>
			</div>
			<cuppa-menu
				class={"dropdown ani-fade-up"}
				target={'.user-info'}
				pos-x={CuppaMenu.POSITION.RIGHT_IN}
				pos-y={CuppaMenu.POSITION.BOTTOM}
				style={{width:200, marginTop:2}}
				contextual-menu={true}
			>
				<button
					className={'dropdown-button'}
					onClick={()=>{
						Utils.redirect(`/users/user/?profile=${cuppa.base64Encode(UserCtrl.getUser().id)}`, {reload:true, forcePath:true})
					}}
				>
					<i className="fa fa-user" aria-hidden="true"></i>
					<span>{Language.value("My Profile")}</span>
				</button>
				<button className={'dropdown-button'} onClick={UserCtrl.logOut}>
					<i className="fa fa-sign-out" aria-hidden="true"></i>
					<span>{Language.value('Log out')}</span>
				</button>
			</cuppa-menu>
		</>
	)
}
